import React, { PureComponent } from 'react';
import { Box } from 'rebass';
import styled from 'styled-components';
import { connect } from 'unistore/react';
import Actions from '~/state/Actions';

import Header from '~/components/Header';
import ChartControls from '~/components/ChartControls';
import Footer from '~/components/Footer';
import Visualisation from '~/components/Visualisation';
import PresetButtons from '~/components/PresetButtons';
import IncomeCalculator from '~/components/IncomeCalculator';

const AppWrapper = styled(Box)`
  height: 100%;
  position: relative;
  max-width: 700px;
`;

class App extends PureComponent {
  componentDidMount() {
    this.props.loadData();
  }

  render() {
    return (
      <AppWrapper px={2} mx="auto">
        <Header />
        <IncomeCalculator />
        <ChartControls />
        <Visualisation />
        <PresetButtons />
        <Footer />
      </AppWrapper>
    );
  }
}

export default connect(null, Actions)(App);
